import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('assetModelSelector');

    return {
        ASSET_MODEL_SELECTOR_LABEL: t('assetModelSelectorLabel'),
        BATTERY: t('battery'),
        DRONE: t('drone')
    };
};

export default useTranslation;
